module.exports = __webpack_public_path__ + "img/073.12520ed5.png";